import { Device } from './device';
import { shelfRack } from './shelfRack';

export interface Vault {
  id: string;
  vaultName: string;
  vaultCode: string;
  vaultCountryLocation: string;
  vaultGPSLocation: string;
  vaultContactPersonName: string;
  vaultContactPersonPhone: string;
  deviceItemByVault: Device[];
  shelfRackItemByVault: shelfRack[];
  Location?:string
}

export const initialVaultData = {
  id: '',
  vaultName: '',
  vaultCode: '',
  vaultCountryLocation: '',
  vaultGPSLocation: '',
  vaultContactPersonName: '',
  vaultContactPersonPhone: '',
  shelfRackItemByVault: [],
  deviceItemByVault: [],
  Location:''
};
